import {getSuggestedUnitToShow} from "./unitsUtility";

/**
 * Devuelve exclusivamente las unidades activas configuradas
 * para una marca/presentación.
 *
 * Si el payload no incluye productBrandUnits, no se ofrecen
 * unidades. Requisiciones debe respetar estrictamente las unidades
 * configuradas para la marca/presentación.
 */
export const getProductBrandUnits = (productBrand) => {

    const configuredUnits = (productBrand?.productBrandUnits || [])
        .filter(pbu => pbu && pbu.isActive !== false && pbu.unit)
        .map(pbu => pbu.unit)
        .filter((unit, index, array) =>
            array.findIndex(other => other.id === unit.id) === index
        );

    return configuredUnits;
};


/**
 * Unidad inicial de una marca.
 *
 * Prioridad:
 * 1. displayUnit si está permitida
 * 2. smallestUnit si está permitida
 * 3. primera unidad configurada para la marca
 */
export const getPreferredProductBrandUnit = (productBrand) => {

    if (!productBrand)
        return null;

    const units = getProductBrandUnits(productBrand);
    const product = productBrand.product;

    if (!units.length)
        return null;

    if (product?.displayUnit) {
        const displayUnit = units.find(
            unit => unit.id === product.displayUnit.id
        );

        if (displayUnit)
            return displayUnit;
    }

    if (product?.smallestUnit) {
        const smallestUnit = units.find(
            unit => unit.id === product.smallestUnit.id
        );

        if (smallestUnit)
            return smallestUnit;
    }

    return units[0];
};


/**
 * Conserva la lógica histórica de sugerencia de unidades,
 * pero evita sugerir una unidad que la marca no tenga habilitada.
 */
export const getSuggestedProductBrandUnit = (quantity, productBrand) => {

    if (!productBrand?.product)
        return null;

    const units = getProductBrandUnits(productBrand);

    if (!units.length)
        return null;

    const suggested = getSuggestedUnitToShow(
        quantity,
        productBrand.product
    );

    const allowedSuggested = units.find(
        unit => unit.id === suggested?.id
    );

    if (allowedSuggested)
        return allowedSuggested;

    return getPreferredProductBrandUnit(productBrand);
};
